import React, { useState, useEffect } from "react";
import { Link, NavLink } from 'react-router-dom';
import './../../styles/cliente/Sidebar.css';

const Sidebar = () => {

    const [user, setUser] = useState([]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }
    }, []);


    return (
        <div className="sidebar">
            <ul>
                <li>
                    <NavLink to="/cliente/menu">Menu semanal</NavLink>
                </li>
                <li>
                    <NavLink to="/cliente/pedidos">Pedidos anteriores</NavLink>
                </li>
                <li>
                    <NavLink to="/cliente/pagos">Pagos</NavLink>
                </li>
                <li>
                    <NavLink to="/cliente/referidos">Referidos</NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;